export default "__VITE_ASSET__DOrfV2m2__"